export let REVIBE_API_URL =
  (process.env.NEXT_PUBLIC_REVIBE_API_URL as string) ||
  (process.env.REACT_APP_REVIBE_API_URL as string);
